import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../utils/network-call/network-call";

export const AdminCompanyEditLoader = async (args: LoaderFunctionArgs) => {
    const getCompanyResponse = await networkCall(`/companies/${ args.params.id }`);
    const getLicensesResponse = await networkCall(`/companies/${ args.params.id }/licenses`)

    return { companyId: args.params.id, getCompanyResponse, getLicensesResponse };
};